<script setup>
import {onMounted, ref} from 'vue';
import ClientReportService from '@/services/ClientReportService';
import LineChart from '@/components/echarts/LineChart.vue';
import PieChart from '@/components/echarts/PieChart.vue';
import DashboardClientComponent from '@/components/dashboard/DashboardClient.vue';
import DashboardIntermediaryComponent from '@/components/dashboard/DashboardIntermediary.vue';
import router from '@/router';
import {useRoute} from 'vue-router';
import Welcome from '@/views/Welcome.vue';
import {authData, getLoggedUser, refreshLoggedUser} from '@/services/AuthService';


const query = useRoute().query;

const loggedClient = ref(null);
const loggedUser = ref(null);

onMounted(async () => {
  getLoggedUser().then(response => {
    loggedClient.value = response.client;
    loggedUser.value = response;

    if(loggedUser.value.role !== 'CLIENT') {
      router.push('/clients');
    }
  });
})



</script>
<template>
  <div v-if="query.welcome === 'true'">
    <Welcome></Welcome>
  </div>
  <div v-if="loggedUser && loggedUser.role === 'CLIENT'">
    <DashboardClientComponent/>
  </div>
  <div v-if="loggedUser && loggedUser.role === 'INTERMEDIARY'">
    <DashboardIntermediaryComponent/>
  </div>
</template>

